import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse } from 'types';

import { api } from 'utils';

const useLDWithdrawConfirm = (): UseMutationResult<
  { id: string },
  ErrorResponse,
  { id: string; data: { code: string } }
> => {
  return useMutation(({ id, data }) =>
    api.put(`${url.lDWithdrawConfirm}/${id}/settle`, data)
  );
};

export default useLDWithdrawConfirm;
